@if (task.type !== taskType.DOCUMENT) {
    <vc-tooltip-text [text]="displayResponse"></vc-tooltip-text>
} @else if (task.type === taskType.DOCUMENT && task.documentCount && task.documentCount > 0) {
    <span class="material-icons vc-task-response-icon"> attach_file </span>
}
